module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-album-ffa85c2622fd8667e0281fed0e2a56b8.jpg";